import { FC, ReactNode } from 'react'
import * as styles from 'components/features/pfm/ConfirmModalLayout/ConfirmModalLayout.css'
import { OverlayContainer } from 'components/features/pfm/Overlay/OverlayContainer'
import { BodyText } from 'components/atoms/Text'

export type ConfirmModalLayoutProps = {
  buttons: ReactNode
  onCancel: () => void
}

export const ConfirmModalLayout: FC<ConfirmModalLayoutProps> = (props) => {
  const { buttons, children, onCancel } = props

  return (
    <OverlayContainer onClose={ onCancel }>
      <section className={ styles.content } data-qa-marker='confirm-modal'>
        <BodyText>
          <span className={ styles.text }>
            { children }
          </span>
        </BodyText>
        <footer className={ styles.buttons }>
          <div className={ styles.buttonRow }>
            { buttons }
          </div>
        </footer>
      </section>
    </OverlayContainer>
  )
}
